module.exports = __webpack_public_path__ + "static/media/wincent-logo.a1709599.JPG";